import React, { useState } from "react";

import { CircularIndeterminate, FormButton } from "components";
import { FormikTextInput } from "components/UI/Inputs/FormikInputs";

import { Form, Formik } from "formik";
import * as yup from "yup";

import { useRecoilValue, useSetRecoilState } from "recoil";
import { rowSelected, snackbarData, userCredentials } from "recoilState/GlobalState";

import styles from "styles/pages/ModalActions.module.scss";
import { handleResponse } from "services/Local-services";
import { usuarioLugarHorarioDel } from "services/services-mia/miakey";
import { Grid } from "@mui/material";

export default function EliminarModal({
    selectedRow,
    updateList,
    closeModal,
}) {
    const [inRequest, setInRequest] = useState(false);

    const setSelected = useSetRecoilState(rowSelected);
    const setSnackbarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);

    const handleSubmit = async () => {
        setInRequest(true);

        const response = await usuarioLugarHorarioDel({
            gateUsuarioLugarHorarioId: selectedRow.gateUsuarioLugarHorarioId,
            gateUsuarioLugarHorarioVersion: selectedRow.gateUsuarioLugarHorarioVersion,
        }, credentials);

        handleResponse(
            response,
            "Estado eliminado exitosamente",
            { setSnackbarInfo, setIsOpen: closeModal, setSelected, updateList }
        );

        setInRequest(false);
    };

    const estadoLabel = selectedRow.gateUsuarioLugarHorarioStatus === "A" ? "Alta" : "Baja";

    return (
        <Formik
            key={selectedRow.gateUsuarioLugarHorarioId}
            initialValues={{
                fecha: selectedRow.gateUsuarioLugarHorarioFH ?? "",
                horario: selectedRow.gateHorarioNombre ?? "",
                estado: estadoLabel,
            }}
            validationSchema={yup.object({})}
            onSubmit={(values, { setSubmitting }) => {
                try {
                    handleSubmit();
                } catch (e) {
                    setSnackbarInfo({ message: e.errmsg, severity: "error", open: true });
                } finally {
                    setSubmitting(false);
                }
            }}
        >
            <Form className={styles.inputs} noValidate>
                <Grid container justifyContent={"center"} spacing={2}>
                    <Grid item xs={12}>
                        <p>¿Desea eliminar el siguiente estado?</p>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FormikTextInput name="fecha" labelText="Fecha" disabled fullWidth />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FormikTextInput name="horario" labelText="Horario" disabled fullWidth />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FormikTextInput name="estado" labelText="Estado" disabled fullWidth />
                    </Grid>
                    <FormButton
                        inRequest={inRequest}
                        newFormData={{ button: "Eliminar" }}
                        onCloseModal={closeModal}
                    />
                    {inRequest && <CircularIndeterminate />}
                </Grid>
            </Form>
        </Formik>
    );
}
